// extracted by mini-css-extract-plugin
export var container = "_nz-0";
export var dotAnimation = "_nz-2";
export var dotsLoading = "_nz-1";